import { render, staticRenderFns } from "./TransferSalesReport.vue?vue&type=template&id=0d0ba37c&scoped=true"
import script from "./TransferSalesReport.vue?vue&type=script&lang=js"
export * from "./TransferSalesReport.vue?vue&type=script&lang=js"
import style0 from "./TransferSalesReport.vue?vue&type=style&index=0&id=0d0ba37c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0ba37c",
  null
  
)

export default component.exports